import React from "react";

type InputProps = React.InputHTMLAttributes<HTMLInputElement> & {
  label?: string;
  error?: string;
  helperText?: string;
};

const Input = ({
  label,
  error,
  helperText,
  className = "",
  style,
  id,
  ...props
}: InputProps) => {
  return (
    <label style={{ display: "block", width: "100%" }}>
      {label ? (
        <span
          style={{
            display: "block",
            fontSize: "14px",
            fontWeight: 600,
            marginBottom: "8px",
            color: "var(--text-primary)",
          }}
        >
          {label}
        </span>
      ) : null}

      <input
        id={id}
        className={className}
        style={{
          width: "100%",
          minHeight: "48px",
          padding: "14px 16px",
          borderRadius: "16px",
          border: "1px solid var(--border)",
          outline: "none",
          background: "var(--surface-alt)",
          color: "var(--text-primary)",
          fontSize: "15px",
          transition: "all var(--transition-base)",
          opacity: props.disabled ? 0.7 : 1,
          ...style,
        }}
        {...props}
      />

      {helperText ? (
        <div
          style={{
            marginTop: "6px",
            fontSize: "12px",
            color: "var(--text-secondary)",
          }}
        >
          {helperText}
        </div>
      ) : null}

      {error ? (
        <div
          style={{
            marginTop: "6px",
            fontSize: "12px",
            color: "var(--danger)",
          }}
        >
          {error}
        </div>
      ) : null}
    </label>
  );
};

export default Input;